import axios from './index';

export default {
    acceptPostCollaboration,
    declinePostCollaboration
};

async function acceptPostCollaboration(id, data) {
    const response = await axios.post(`/api/post-collaboration-requests/${id}/accept`, data);
    return response.data;
}

async function declinePostCollaboration(id, data) {
    const response = await axios.post(`/api/post-collaboration-requests/${id}/decline`, data);
    return response.data;
}

